/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_D1dInputs */

const en_mk_sol_lembaga_d1d = /** @type {(inputs: Mk_Sol_Lembaga_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new volunteer follows the same steps as the last one, with no repeated training.`)
};

const id_mk_sol_lembaga_d1d = /** @type {(inputs: Mk_Sol_Lembaga_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relawan baru mengikuti langkah yang sama seperti relawan sebelumnya, tanpa perlu pelatihan berulang.`)
};

/**
* | output |
* | --- |
* | "A new volunteer follows the same steps as the last one, with no repeated training." |
*
* @param {Mk_Sol_Lembaga_D1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_d1d = /** @type {((inputs?: Mk_Sol_Lembaga_D1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_D1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_d1d(inputs)
	return en_mk_sol_lembaga_d1d(inputs)
});